export default "__VITE_ASSET__DpKEf6Pr__ 600w";